

















































import dateFormat from 'date-fns/format'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { getCvsTypeLabel } from '@/models/purhase/cvs_type'
import { formatPrice } from '@/util/format'
import { OrderResultSuccess } from '@spa/store/modules/orderConfirm/types'

@Component({})
export default class OrderCvsNumberResult extends Vue {
  @Prop({ required: true })
  results: OrderResultSuccess[]

  get hasMultiResult() {
    return this.results.length > 1
  }

  genUniqueKey(result: OrderResultSuccess): string {
    return result.order.cartItems.map(i => i.id).join('_')
  }

  getCvsType(result: OrderResultSuccess): string {
    const cvsType = _.get(result.commerceSalesOrder, 'payment.method.cvs_type')

    return getCvsTypeLabel(cvsType)
  }

  getAuthNumber(result: OrderResultSuccess): string {
    return _.get(result.commerceSalesOrder, 'cvsNumberResult.authNumber')
  }

  getExpireDate(result: OrderResultSuccess): string {
    return dateFormat(
      _.get(result.commerceSalesOrder, 'cvsNumberResult.expireDate'),
      'YYYY年MM月DD日'
    )
  }

  getTotalPrice(result: OrderResultSuccess): string {
    return formatPrice(result.commerceSalesOrder.totalPrice)
  }
}
